import { Map as ImmutableMap } from 'immutable';
import get from 'transmute/get';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import UIImage from 'UIComponents/image/UIImage';
import { getThumbnailUrl } from 'FileManagerLib/utils/thumbnail';
import { IMG } from 'conversations-message-history/common-message-format/constants/fileAttachmentTypes';
import AttachmentPreview from './AttachmentPreview';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { jsx as _jsx } from "react/jsx-runtime";
const UploadedFile = props => {
  const {
    onRemove,
    uploadedFile
  } = props;
  const immutableUploadedFile = ImmutableMap.isMap(uploadedFile) ? uploadedFile : ImmutableMap(uploadedFile);
  const size = immutableUploadedFile.get('size');
  const name = immutableUploadedFile.get('name');
  const extension = immutableUploadedFile.get('extension');
  const type = immutableUploadedFile.get('type');
  const fileName = `${name}.${extension}`;
  const showImagePreview = type === IMG && extension !== 'svg';
  const handleRemove = useCallback(() => {
    onRemove(immutableUploadedFile);
  }, [onRemove, immutableUploadedFile]);
  const preview = showImagePreview ? /*#__PURE__*/_jsx(UIImage, {
    alt: fileName,
    src: get('thumbnailUrl', immutableUploadedFile) || getThumbnailUrl(immutableUploadedFile) // method parameter requires a type that is not exported from FileManagerCore.
  }) : undefined;
  return /*#__PURE__*/_jsx(AttachmentPreview, {
    name: fileName,
    size: size,
    removeAttachment: handleRemove,
    preview: preview
  });
};
UploadedFile.displayName = 'UploadedFile';
UploadedFile.propTypes = {
  onRemove: PropTypes.func.isRequired,
  uploadedFile: ImmutablePropTypes.map
};
export default UploadedFile;